import { CommonModule } from '@angular/common';
import {
  Component,
  computed,
  effect,
  ElementRef,
  inject,
  model,
  OnInit,
  output,
  signal,
  viewChild,
} from '@angular/core';
import { TranslocoModule, TranslocoService } from '@jsverse/transloco';
import QRCodeStyling from 'styled-qr-code';
import { BusinessService } from '../../services/business.service';
import { AccountTypeCode, PaymentAccount } from '../../schemas/payment_account';
import { environment } from '../../../../environments/environment';
import { Share } from '@capacitor/share';

@Component({
  selector: 'qwiko-qr-code',
  imports: [CommonModule, TranslocoModule],
  templateUrl: './qr-code.component.html',
  styleUrl: './qr-code.component.scss',
})
export class QrCodeComponent implements OnInit {
  businessService = inject(BusinessService);
  translocoService = inject(TranslocoService);

  canvas = viewChild<ElementRef<HTMLDivElement>>('canvas');
  selectedPaymentAccount = model<PaymentAccount | null>();
  qr: any;

  copying = signal<boolean>(false);
  hasCopied = output<boolean>();
  hasShared = output<boolean>();
  canDownload = model<boolean>(true);
  canCopy = model<boolean>(true);
  canShare = model<boolean>(true);
  hasOfflineToggle = model<boolean>(false);
  amount = model<number | null>(0);
  transactionCode = model<string | null>(null);
  ussdAmount = computed(() => {
    if (this.amount() === null || this.amount() === 0) {
      return 0;
    }

    // let number: string | number = this.amount()!;

    // number = number.replace(/[\s,]/g, '');
    // number = number.replace(/[^0-9,]/g, '');

    return this.amount();
  });
  isOffLineMode = model<boolean>(false);
  addPaymentAccount = output<boolean>();
  trigger = computed<string>(() => {
    let number = '0';
    if (this.isOffLineMode()) {
      number = this.selectedPaymentAccount()?.number_display || '0';
    } else {
      number = this.selectedPaymentAccount()?.number || '0';
    }
    const amount = this.ussdAmount()?.toString() || '0';

    const trigger = this.ussd()
      .replace(':number', number)
      .replace(':code', number)
      .replace(':amount', amount);

    return trigger;
  });

  ussd = computed<string>(() => {
    if (
      this.isOffLineMode() &&
      this.selectedPaymentAccount()?.type?.code === AccountTypeCode.MOMO
    ) {
      return '*182*1*1*:number*:amount#';
    }

    return '*182*8*1*:code*:amount#';
  });

  paymentLink = computed(() => {
    if (this.isOffLineMode()) {
      return this.offlinePaymentLink();
    } else {
      return `${environment.qrUrl}/?t=${this.transactionCode()}`;
    }
    // if (this.transactionCode()) {
    //   return `${environment.qrUrl}/?t=${this.transactionCode()}`;
    // }
    // if (this.selectedPaymentAccount()) {
    //   let link: string = '';
    //   if (this.isOffLineMode()) {
    //     return this.offlinePaymentLink();
    //   }

    //   link = `${environment.qrUrl}/?a=${this.selectedPaymentAccount()?.code}`;
    //   if (this.ussdAmount()) {
    //     link = `${environment.qrUrl}/?a=${this.selectedPaymentAccount()?.code}&am=${this.ussdAmount()}`;
    //   }
    //   return link;
    // } else if (this.businessService.business()?.code) {
    //   let link: string = '';
    //   if (this.isOffLineMode()) {
    //     return this.offlinePaymentLink();
    //   }
    //   link = `${environment.qrUrl}/?b=${this.businessService.business()?.code}`;
    //   if (this.ussdAmount()) {
    //     link = `${environment.qrUrl}/?b=${this.businessService.business()?.code}&am=${this.ussdAmount()}`;
    //   }
    //   return link;
    // } else {
    //   return null;
    // }
  });

  link = model<string>('');

  constructor() {
    effect(() => {
      if (this.link() || this.paymentLink()) {
        if (this.canvas() && this.canvas()?.nativeElement) {
          this.canvas()!.nativeElement.innerHTML = '';
          this.generateQrCode();
        }
      } else {
      }
    });
  }

  ngOnInit(): void {
    this.generateQrCode();
  }

  toggleOffLineMode(event: any) {
    event.preventDefault();
    if (this.selectedPaymentAccount() == null) {
      this.addPaymentAccount.emit(true);
      return;
    }
    this.isOffLineMode.set(!this.isOffLineMode());
  }

  offlinePaymentLink(): string | null {
    // console.log('offlinePaymentLink', this.isOffLineMode());
    // if (this.selectedPaymentAccount() == null) {
    //   this.addPaymentAccount.emit(true);
    //   return null;
    // }

    return `tel://${this.trigger()}`;
  }

  copy() {
    this.copying.set(true);
    this.hasCopied.emit(true);
    setTimeout(() => this.copying.set(false), 2000);
    const value = this.translocoService.translate('share_text', {
      business_name: this.businessService.business()?.name,
    });
    const share_text = `${value}\n\n${this.link() || this.paymentLink()}`;
    const shareData = {
      text: share_text,
    };
    navigator.clipboard.writeText(share_text).then(() => {});
  }

  async share() {
    this.hasShared.emit(true);
    const value = this.translocoService.translate('share_text', {
      business_name: this.businessService.business()?.name,
    });
    const share_text = `${value}\n\n${this.link() || this.paymentLink()}`;
    const shareData = {
      text: share_text,
      url: this.link() || this.paymentLink() || '',
    };
    // console.trace('shareData', shareData);
    await Share.share(shareData);
  }

  generateQrCode() {
    if (this.link() || this.paymentLink()) {
      this.qr = new QRCodeStyling({
        width: 300,
        height: 300,
        type: 'svg',
        data: this.link() || this.paymentLink() || '',
        image: './assets/logo/qwiko360-icon-sqr-dark.svg',
        margin: 5,
        qrOptions: {
          typeNumber: 0,
          mode: 'Byte',
          errorCorrectionLevel: 'H',
        },
        imageOptions: {
          imageSize: 0.3,
          hideBackgroundDots: true,
          margin: 5,
          crossOrigin: 'anonymous',
        },
        dotsOptions: {
          color: '#5100AE',
          type: 'classy',
        },
        backgroundOptions: {
          color: '#ffffff',
        },
        cornersSquareOptions: {
          color: '#5100AE',
          type: 'extra-rounded',
        },
        cornersDotOptions: {
          color: '#5100AE',
          type: 'dot',
        },
      });

      this.qr.append(this.canvas()?.nativeElement);
      setTimeout(() => {
        this.qr;
        // this.qr.innerHTML += '<span class=""> Qwiko360 </span>';
      }, 3000);
    }
  }

  download() {
    this.qr.download({
      name: this.businessService.business()?.name + '@qwiko',
      extension: 'png',
    });
  }
}
